import { Component, OnInit } from "@angular/core";
import { environment } from "src/environments/environment";
import {
    NgbModalConfig,
    NgbModal,
    NgbModalOptions,
    ModalDismissReasons,
} from "@ng-bootstrap/ng-bootstrap";
import { Router } from "@angular/router";
import { HttpClient } from "@angular/common/http";
import {
    FormControl,
    FormsModule,
    Validators,
    FormGroup,
} from "@angular/forms";

@Component({
    selector: "app-saved-invoices-nonpo",
    templateUrl: "./saved-invoices-nonpo.component.html",
    styleUrls: ["./saved-invoices-nonpo.component.scss"],
})
export class SavedInvoicesNonpoComponent implements OnInit {
    docs = [
        {
            docType: "ZSUB",
            descrption: "PO - Subcontracting",
        },
        {
            docType: "NO1G",
            descrption: "NO1G",
        },
    ];

    companies = [
        {
            code: "1000",
            companyName: "JSW Steel Limited",
        },
        {
            code: "1001",
            companyName: "JSW SPCL",
        },
        {
            code: "1002",
            companyName: "JSW Projects",
        },
        {
            code: "1004",
            companyName: "JSW Ind. Gases Pvt. Ltd",
        },
        {
            code: "1006",
            companyName: "JSW VJNR Metallics Ltd.",
        },
        {
            code: "1010",
            companyName: "JSW Steel Coated Products",
        },
        {
            code: "1030",
            companyName: "Amba River Coke Limited",
        },
        {
            code: "1050",
            companyName: "Dolvi Coke Projects Ltd",
        },
        {
            code: "1060",
            companyName: "JSW Steel Salav Limited",
        },
        {
            code: "1070",
            companyName: "JSW Utkal Steel Limited",
        },
        {
            code: "1080",
            companyName: "JSW ISPAT Special Products",
        },
        {
            code: "1900",
            companyName: "Asian Colour Coated Ispat",
        },
    ];

    organisations = [
        {
            code: "P990",
            CompanyName: "JSW GBS",
        },
        {
            code: "P192",
            CompanyName: "ACCIL - BAWAL",
        },
        {
            code: "P190",
            CompanyName: "ACCIL - HO",
        },
        {
            code: "P913",
            CompanyName: "JSW RETAIL LTD-CORP",
        },
        {
            code: "P930",
            CompanyName: "JSW ONE PLATFORMS",
        },
        {
            code: "P950",
            CompanyName: "JSW Retail & Dist.",
        },
        {
            code: "P961",
            CompanyName: "JSW Foundation-JSMSH",
        },
        {
            code: "P107",
            CompanyName: "DOLVI",
        },
        {
            code: "P109",
            CompanyName: "TPML",
        },
        {
            code: "P313",
            CompanyName: "JSWC Dolvi Works",
        },
        {
            code: "P317",
            CompanyName: "JSWC RMC Dolvi Works",
        },
        {
            code: "P503",
            CompanyName: "JSW Infra,Dharamtar",
        },
        {
            code: "P530",
            CompanyName: "JSWDharamtar Pur Org",
        },
        {
            code: "P560",
            CompanyName: "JSW JDRL Purch Org",
        },
        {
            code: "P502",
            CompanyName: "JSW Infra , Goa",
        },
        {
            code: "P520",
            CompanyName: "JSW SWPL Purch Org",
        },
        {
            code: "P501",
            CompanyName: "JSW Infra , Jaigarh",
        },
        {
            code: "P191",
            CompanyName: "ACCIL - KHOPOLI",
        },
        {
            code: "P118",
            CompanyName: "JSWSCP Kalmeshwar",
        },
        {
            code: "P311",
            CompanyName: "JSWC Nandyal Works",
        },
        {
            code: "P172",
            CompanyName: "JSWUGL - PARADIP",
        },
        {
            code: "P173",
            CompanyName: "JSWUGL - Bhubaneswar",
        },
        {
            code: "P315",
            CompanyName: "JSWC ODISHA WORKS",
        },
        {
            code: "P945",
            CompanyName: "TPML -JAJPUR",
        },
        {
            code: "4000",
            CompanyName: "JSW Energy",
        },
        {
            code: "P180",
            CompanyName: "MUMBAI HO - Raigarh",
        },
        {
            code: "P314",
            CompanyName: "JSWC SALBONI WORKS",
        },
        {
            code: "P102",
            CompanyName: "Salem",
        },
        {
            code: "P318",
            CompanyName: "JSWC - Salem Works",
        },
        {
            code: "P108",
            CompanyName: "SALAV",
        },
        {
            code: "P111",
            CompanyName: "Salav Stock Yard",
        },
        {
            code: "P127",
            CompanyName: "SALAV WORKS",
        },
        {
            code: "P104",
            CompanyName: "Tarapur",
        },
        {
            code: "P114",
            CompanyName: "JSWSCP Tarapur",
        },
        {
            code: "P103",
            CompanyName: "Vasind",
        },
        {
            code: "P113",
            CompanyName: "JSWSCP Vasind",
        },
        {
            code: "P212",
            CompanyName: "JPPL - VASIND",
        },
        {
            code: "P061",
            CompanyName: "VJNR Metallics",
        },
        {
            code: "P101",
            CompanyName: "Vijayanagar",
        },
        {
            code: "P140",
            CompanyName: "JSWBSL Purchase Org",
        },
        {
            code: "P141",
            CompanyName: "JPOPL Vijayanagar",
        },
        {
            code: "P151",
            CompanyName: "Vijayanagar Mines",
        },
        {
            code: "P201",
            CompanyName: "SPCL",
        },
        {
            code: "P211",
            CompanyName: "JPPL - VIJAYNAGAR",
        },
        {
            code: "P301",
            CompanyName: "JSW Projects",
        },
        {
            code: "P312",
            CompanyName: "JSWC Vijayanag Works",
        },
        {
            code: "P902",
            CompanyName: "JSW RIPL Purch Org",
        },
        {
            code: "P906",
            CompanyName: "JSW Foundation",
        },
        {
            code: "P944",
            CompanyName: "TPML Pur Org_VJNR",
        },
    ];

    invoiceDetails: any;
    closeResult: string = "";
    modalOptions: NgbModalOptions;
    loading: boolean = false;
    uploadSuccessful: boolean = false;
    saving: boolean = false;
    uploadInvoice: boolean = false;
    displayName: any;
    hasError: boolean = false;
    imgUrl: string = "";
    typeError: boolean = false;
    sizeError: boolean = false;
    fileTypeError: boolean = false;
    fileSizeError: boolean = false;
    invoiceSaved: boolean = false;
    savingError: boolean = false;
    validationError: boolean = false;
    serverError: boolean = false;
    supportingDocuments: any[] = [];
    agreed = [{ status: false }];
    masterData: any;
    responseData: any;
    isError = false;
    vendorData: any;
    pdfSrc: any;
    /** Demo PDF URL; middle path segment comes from `environment.extractedPdfsS3Prefix`. */
    readonly extractedPdfDemoSrc =
        "https://jsw-documents.s3.ap-south-1.amazonaws.com/" +
        environment.extractedPdfsS3Prefix +
        "/7859017e9dd682243c29db761b063c84a07358182fca44f55cd4d9aa07a3c0c1.pdf?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Date=20221128T103023Z&X-Amz-SignedHeaders=host&X-Amz-Expires=600&X-Amz-Credential=AKIA5DL5POTX4TWFOX7Q%2F20221128%2Fap-south-1%2Fs3%2Faws4_request&X-Amz-Signature=4e67c0f762278fa5c0d78654e625e6efa6a6d5d760446832d439f335705d3f6a";
    invoiceFile: any;
    invoiceDataToSave: any;
    isInvoiceChange: boolean = false;
    isUpdatedData: boolean = false;
    invoiceChanged: boolean = false;
    isCondensed: boolean = false;
    currentLayout = {
        isCondensed: true,
    };

    extractedInvoiceNonPo = new FormGroup({
        invoiceType: new FormControl("e-invoice"),
        file: new FormControl(null),

        //reuploadFile: new FormControl(null),
        supportingFiles: new FormControl(null),
        fileSource: new FormControl(""),
        documentSource: new FormControl(""),
        terms_agreed: new FormControl(null, [Validators.required]),
        emailAddress: new FormControl("", [
            Validators.required,
            Validators.email,
            Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$"),
        ]),
        companyCode: new FormControl("", [Validators.required]),
        purchaseOrg: new FormControl("", [Validators.required]),
        docType: new FormControl("", [Validators.required]),
    });

    extractInvoiceData(data: any) {
        return this.http.post(
            "https://jsw.qa.payex.live/api/dashboard/extractInvoiceData",
            data
        );
    }

    validateNonPoInvoice(data: any) {
        return this.http.post(
            "https://jsw.qa.payex.live/api/dashboard/uploadInvoice",
            data
        );
    }

    saveNonPoInvoice(data: any) {
        return this.http.post(
            "https://jsw.qa.payex.live/api/dashboard/saveInvoiceUploadProcess",
            data
        );
    }

    getInvoice(data: any) {
        return this.http.post(
            "https://jsw.qa.payex.live/api/dashboard/fetchInvoice",
            data
        );
    }

    constructor(
        private modalService: NgbModal,
        private router: Router,
        private http: HttpClient
    ) {
        this.modalOptions = {
            backdrop: "static",
            backdropClass: "customBackdrop",
            scrollable: true,
        };
    }

    toggleSidebar() {
        this.currentLayout.isCondensed = !this.currentLayout.isCondensed;
        document.body.setAttribute(
            "data-sidebar-size",
            this.currentLayout.isCondensed ? "condensed" : "default"
        );
    }

    selectDocuments(event: any) {
        for (var i = 0; i < event.length; i++) {
            if (event[i].type !== "application/pdf") {
                this.typeError = true;
                this.sizeError = false;
            } else if (event[i].size > 5042157) {
                this.sizeError = true;
                this.typeError = false;
            } else {
                this.sizeError = false;
                this.typeError = false;
                this.supportingDocuments.push(event[i]);
            }
        }
        //console.log(this.supportingDocuments);
    }

    reUploadInvoice(event: any) {
        if (event.length > 0) {
            const fileUploaded = event[0];

            //console.log(fileUploaded);

            if (fileUploaded.type !== "application/pdf") {
                this.hasError = false;
                this.fileSizeError = false;
                this.fileTypeError = true;
            } else if (fileUploaded.size > 5042157) {
                this.fileTypeError = false;
                this.hasError = false;
                this.fileSizeError = true;
            } else {
                this.fileSizeError = false;
                this.fileTypeError = false;

                if (typeof FileReader !== "undefined") {
                    let reader = new FileReader();
                    reader.onload = (e: any) => {
                        this.pdfSrc = e.target.result;
                        //console.log(this.pdfSrc);
                    };
                    let $file: any = fileUploaded;
                    reader.readAsArrayBuffer($file);
                }

                this.extractedInvoiceNonPo.patchValue({
                    fileSource: fileUploaded,
                });

                this.hasError = false;
                this.isInvoiceChange = true;

                const userData = {
                    req: {
                        emailAddress:
                            this.extractedInvoiceNonPo.value.emailAddress,
                        companyCode:
                            this.extractedInvoiceNonPo.value.companyCode,
                        purchaseOrg:
                            this.extractedInvoiceNonPo.value.purchaseOrg,
                        docType: this.extractedInvoiceNonPo.value.docType,
                        items: [{ poNo: "", itemNo: "", grn: "" }],
                    },
                };

                this.loading = true;
                this.invoiceChanged = true;

                //console.log(userData);

                //console.log(localStorage.getItem("eippSession"));

                const formData: any = new FormData();
                // formData.append('poNo', this.route.snapshot.params['poNo']);
                formData.append(
                    "sellerCode",
                    localStorage.getItem("vendorCode")
                );
                formData.append(
                    "sessionId",
                    localStorage.getItem("eippSession")
                );
                formData.append("invoiceType", "e-invoice");
                formData.append("req", JSON.stringify(userData.req));
                formData.append(
                    "file",
                    this.extractedInvoiceNonPo.value.fileSource
                );

                // for (const value of formData.values()) {
                //     console.log(value);
                // }

                this.extractInvoiceData(formData).subscribe(
                    (res) => {
                        this.loading = false;
                        this.invoiceChanged = false;
                        this.isUpdatedData = true;
                        this.responseData = res;
                        //console.log(res);
                        if (
                            this.responseData.length !== 0 &&
                            this.responseData.status === "error"
                        ) {
                            console.log(this.responseData.message);
                        } else {
                            //console.log("Success hereresponseData");
                            this.invoiceDetails = this.responseData;
                        }
                    },
                    (error) => {
                        console.log(error.msg);
                    }
                );
            }
        }
    }

    /**
     * Delete file from files list
     * @param index (File index)
     */
    deleteFile(index: number) {
        this.supportingDocuments.splice(index, 1);
        if (this.supportingDocuments.length === 0) {
            this.extractedInvoiceNonPo.patchValue({
                documentSource: "",
            });
        }
    }

    open(content: any) {
        this.modalService.open(content, this.modalOptions).result.then(
            (result) => {
                this.closeResult = `Closed with: ${result}`;
            },
            (reason) => {
                this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
            }
        );
    }

    private getDismissReason(reason: any): string {
        if (reason === ModalDismissReasons.ESC) {
            return "by pressing ESC";
        } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
            return "by clicking on a backdrop";
        } else {
            return `with: ${reason}`;
        }
    }

    saveUploadData() {
        this.loading = true;
        this.saving = true;
        //this.uploadInvoice = false;

        const invoiceData = {
            sellerCode: localStorage.getItem("vendorCode"),
            session: { sessionId: localStorage.getItem("eippSession") },
            data: {
                irn: this.invoiceDetails.irn,
                invoice_number: this.invoiceDetails.invoice_number,
                file_link: this.invoiceDetails.file_link,
                gstin: this.invoiceDetails.gstin,
                invoice_date: this.invoiceDetails.invoice_date,
                invoice_amount: this.invoiceDetails.invoice_amount,
                terms_agreed: false,
                errors: [],
                supporting_docs: this.invoiceDetails.supporting_docs,
                emailAddress: this.extractedInvoiceNonPo.value.emailAddress,
                companyCode: this.extractedInvoiceNonPo.value.companyCode,
                purchaseOrg: this.extractedInvoiceNonPo.value.purchaseOrg,
                docType: this.extractedInvoiceNonPo.value.docType,
                items: this.invoiceDetails.items,
            },
        };

        this.saveNonPoInvoice(invoiceData).subscribe(
            (res) => {
                this.responseData = res;
                if (this.responseData.status == "successful") {
                    this.saving = false;
                    this.uploadInvoice = false;
                    this.uploadSuccessful = false;
                    this.savingError = false;
                    this.serverError = false;
                    this.hasError = false;
                    this.invoiceSaved = true;
                } else {
                    this.saving = false;
                    this.invoiceSaved = false;
                    this.uploadInvoice = false;
                    this.uploadSuccessful = false;
                    this.hasError = false;
                    this.serverError = false;
                    this.savingError = true;
                }

                //console.log(res);
            },
            (error) => {
                this.saving = false;
                this.invoiceSaved = false;
                this.uploadInvoice = false;
                this.uploadSuccessful = false;
                this.serverError = false;
                this.savingError = true;
                //console.log(error);
            }
        );
    }

    onSubmit() {
        this.loading = true;
        this.uploadInvoice = true;

        const userData = {
            companyCode: this.invoiceDetails.company_code,
            purchaseOrg: this.invoiceDetails.purchase_org,
            docType: this.invoiceDetails.doc_type,
            emailAddress: this.invoiceDetails.email_address,
            items: [{ poNo: "", itemNo: "", grn: "" }],
            termsAgreed: true,
        };

        if (this.isInvoiceChange === true) {
            this.invoiceFile = this.extractedInvoiceNonPo.value.fileSource;
        } else {
            this.invoiceFile = this.invoiceDetails.file;
        }

        //console.log(localStorage.getItem("eippSession"));

        const formData: any = new FormData();
        formData.append("sellerCode", localStorage.getItem("vendorCode"));
        formData.append("sessionId", localStorage.getItem("eippSession"));
        formData.append("invoiceType", "e-invoice");
        formData.append("req", JSON.stringify(userData));
        formData.append("file", this.invoiceFile);

        //console.log(this.supportingDocuments);

        if (this.supportingDocuments.length !== 0) {
            for (let i = 0; i < this.supportingDocuments.length; i++) {
                formData.append("supportingDocs", this.supportingDocuments[i]);
            }
        } else {
            formData.append("supportingDocs", this.supportingDocuments);
        }

        // for (const value of formData.values()) {
        //     console.log(value + " This is formdata");
        // }

        if (!this.saving) {
            this.validateNonPoInvoice(formData).subscribe(
                (res) => {
                    this.responseData = res;
                    //console.log(this.responseData.status);

                    if (this.responseData.status === "error") {
                        console.log("error exist");
                        this.loading = false;
                        this.uploadInvoice = false;
                        this.hasError = true;
                    } else {
                        this.uploadSuccessful = true;
                        this.uploadInvoice = false;
                    }
                },
                (error) => {
                    this.uploadInvoice = false;
                    this.uploadSuccessful = false;
                    this.invoiceSaved = false;
                    this.serverError = true;
                    // console.log(error);
                }
            );
        }
        this.modalService.dismissAll();
        //
    }

    ngOnInit(): void {
        this.displayName = localStorage.getItem("displayName");

        const userData = {
            irn: localStorage.getItem("irn"),
            action: "savedGet",
            sellerCode: localStorage.getItem("vendorCode"),
            session: { sessionId: localStorage.getItem("eippSession") },
        };

        this.loading = true;

        this.getInvoice(userData).subscribe(
            (res) => {
                this.loading = false;
                this.responseData = res;
                //console.log(this.responseData);
                if (this.responseData.status === "successful") {
                    // console.log("You did it");
                    this.invoiceDetails = this.responseData.savedInvoice;
                    this.extractedInvoiceNonPo.patchValue({
                        purchaseOrg: this.invoiceDetails.purchaseOrg,
                        docType: this.invoiceDetails.docType,
                        emailAddress: this.invoiceDetails.emailAddress,
                        companyCode: this.invoiceDetails.companyCode,
                    });
                    //console.log(this.invoiceDetails);
                } else {
                    this.loading = false;
                    console.log(res);
                    console.log("error");
                }
            },
            (error) => {
                if (error.status === 401) {
                    // this.sessionExpired = true;
                    // this.errorMsg = error.error.msg;
                    this.loading = false;
                    console.log(error);
                }
            }
        );
    }

    closeSuccessDialog() {
        this.loading = false;
        this.router.navigateByUrl("/invoices");
    }

    viewSavedInvoices() {
        this.router.navigate(["/saved-invoices"]);
    }

    closeErrorDialog() {
        this.loading = false;
        this.savingError = false;
        this.serverError = false;
    }
    onCheckboxChange(e: any) {
        //console.log(e);
        if (e.target.checked) {
            this.extractedInvoiceNonPo.patchValue({
                terms_agreed: e.target.value,
            });
        } else {
            this.extractedInvoiceNonPo.patchValue({
                terms_agreed: null,
            });
        }
    }
}
